import _ from 'lodash'

/**
 * graphql の query から pick 用の keys オブジェクトを生成する.
 * @param {String} query graphql の query.
 * @param {Number} startPoint 解析の起点とする行.(0オリジン)
 */
function createKeys (query, startPoint = 0) {
  /**
   * graphql の query から pick 用の keys オブジェクトを生成する.
   * @param {String[]} lines graphql の query を行単位に分割したStringの配列.
   * @param {*} index 現在行.
   * @param {*} dest 出力先.
   */
  const create = (lines, index, dest) => {
    if (lines.length === index) {
      return
    }
    for (let i = index; i < lines.length; i++) {
      if (lines[i].endsWith('{')) {
        let key = _.trim(lines[i], ' {')
        // 条件文を含む場合条件部分を削除
        if (key.indexOf('(') >= 0) {
          key = key.substr(0, key.indexOf('(')).trim()
        }
        dest[key] = {}
        i = create(lines, i + 1, dest[key])
      } else if (lines[i] === '}') {
        return i
      } else {
        dest[lines[i]] = null
      }
    }
  }
  let lines = _.chain(query)
    .split('\n')
    .map(_.trim)
    .filter((value) => { return value })
    .value()
  let result = {}
  create(lines, startPoint + 1, result)
  return result
}

/**
 * src から keys に一致する要素を取り出す.
 * @param {Object} src 元データ.
 * @param {Object} keys src から取得する要素のキー.
 * @example
 * src: {
 *   id: 1,
 *   orderNo: 'order1',
 *   site: { code: 1001, name: 'site name' },
 *   qty: { current: '2.00', ordered: '0.00' },
 *   items: [
 *     {
 *       name: 'item1'
 *       qty: { current: '1.00', ordered: '0.00' }
 *     },
 *     {
 *       name: 'item2'
 *       qty: { current: '1.00', ordered: '0.00' }
 *     }
 *   ]
 * }
 * keys: {
 *   id: null,
 *   site: { code: null, name: null },
 *   items: {
 *     qty: { current: null, ordered: null }
 *   }
 * }
 * output: {
 *   id: 1,
 *   site: { code: 1001, name: 'site name' },
 *   items: [
 *     { qty: { current: '1.00', ordered: '0.00' } },
 *     { qty: { current: '1.00', ordered: '0.00' } }
 *   ]
 * }
 */
function pick (src, keys) {
  let picked = _.chain(src)
    .pick(_.keys(keys))
    .cloneDeep()
    .value()
  _.forEach(picked, (value, key) => {
    if (Array.isArray(value)) {
      _.forEach(value, (item, index) => {
        picked[key][index] = pick(item, keys[key])
      })
    } else if (typeof value === 'object') {
      picked[key] = pick(value, keys[key])
    }
  })
  return picked
}

export default {
  createKeys,
  pick
}
